<template>
  <div class="account-password">

    <!-- Button -->
    <div>
      <button type="button"
              class="btn btn-primary btn-bold m-l-10"
              @click="showModal"
              @click.stop="">
        Use Account Password
      </button>
    </div>


    <!--Modal -->
    <div ref="setter"
         class="modal fade"
    >
      <div class="modal-dialog modal-sm" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <i class="fa fa-close close" data-dismiss="modal" aria-label="Close" aria-hidden="true"></i>
            <h4 class="modal-title">Use Account Password</h4>
          </div>
          <div class="modal-body">

            <app-message-list
                :form_errors="form_errors"
            ></app-message-list>

            <div class="col-sm-10 p-t-15">
              <div class="form-group">
                <label>Account Number</label>
                <span class="fg-line">
                                    <input class="form-control" placeholder="Account Number"
                                           v-model="account_nbr" disabled type="text">
                                </span>
              </div>
              <div class="form-group">
                <label>Account Password</label>
                <span class="fg-line">
                                    <input class="form-control" placeholder="Account Password"
                                           v-model="account_password" ref="password" type="password"
                                           v-on:keyup.enter="approveMyAccount()">
                                </span>
              </div>
            </div>

          </div>
          <div class="modal-footer ">
            <button type="button" class="btn btn-lg btn-secondary m-t-30 m-b-20 "
                    :class="{  disabled : is_processing }" data-dismiss="modal">
              <i class="fa fa-times"></i> Close
            </button>
            <button type="button" class="btn btn-lg btn-primary m-t-30 m-b-20"
                    :class="{disabled : is_processing}"
                    @click="approveMyAccount()">
              <i class="fa fa-check"></i> Verify
            </button>
          </div>
        </div>
      </div>
    </div>


  </div>

</template>
<style lang="scss">



  .account-password {
    display: inline-block;
  }


</style>

<script>
  export default {
    props: {
      account_nbr: "",
      user_account_roles: {}
    },

    data: function () {
      return {
        form_errors: [],
        setter: null,
        account_password: null,
        is_processing: false,
        response: {},
      }
    },

    methods: {

      showModal: function () {
        this.setter.modal('show');
      },

      approveMyAccount: function () {
        this.form_errors = [];
        this.is_processing = true;

        this.$http.post('/my/account-roles/selfApprove',
            {
              'account_nbr': this.account_nbr,
              'account_pswd': this.account_password,
              'roles_array': Object.keys(this.user_account_roles),
            })
            .then(function (response) {
              this.is_processing = false;
              this.$emit('approveAccountRoles', response.body.user_account);
              this.is_process = false;
              this.setter.modal('hide');
            })
            .catch(function (data, status, request) {
              this.form_errors = ['Invalid Account Credentials.'];
              this.is_processing = false;
            })

      },
    },

    mounted: function () {
      var vm = this;
      vm.setter = $(vm.$refs.setter);
      vm.setter.on('hidden.bs.modal', function () {
        vm.$emit('closed')
      });
      $('body').append(vm.setter);
    }
  }


</script>




// WEBPACK FOOTER //
// account-password-add.vue?8c1c83ea